const DocRoleEnum = Object.freeze({
  DOC_OWNER: 'doc-owner',
  DOC_VIEWER: 'doc-viewer',
  DOC_EDITOR: 'doc-editor',
  DOC_DOWNLOADER: 'doc-downloader'
});

export default DocRoleEnum;
